import { motion } from "motion/react";

import { useTheme } from "@up/data";
import { Toast, ToastTitle } from "@up/ui";

const reload = function () {
  window.location.reload();
};

const MOTION = {
  props: {
    animate: {
      opacity: 1,
      rotate: 0,
      y: 0,
    },
    initial: {
      opacity: 0,
      rotate: -9,
      y: 100,
    },
    transition: {
      type: "spring",
      mass: 1,
      stiffness: 150,
    },
  },
} as const;

export function ScholarshipFetchError() {
  const theme = useTheme();

  return (
    <div>
      <motion.div {...MOTION.props}>
        <Toast variant="error">
          <ToastTitle>This is embarrassing</ToastTitle>
          We're having trouble loading your application. You can try again or{" "}
          <a className="underline" href={`mailto:${theme.supportEmail}`}>
            email support
          </a>
          .
        </Toast>
      </motion.div>

      <br />

      <button className={theme.buttonPrimaryClass} onClick={reload}>
        Try Again
      </button>
    </div>
  );
}
